import {api} from '@/shared/services/api-client';

export const authApi = {
  me: () => api.auth.me(),
  register: (data: {email: string; password: string; name: string; role?: string}) =>
    api.auth.register(data),
  login: (data: {email: string; password: string}) => api.auth.login(data),
  ssoCallback: (data: {
    access_token: string;
    id_token?: string;
    refresh_token?: string;
    expires_in?: number;
  }) => api.auth.sso.callback(data),
  entraCallback: (data: {accessToken: string}) => api.auth.entra.callback(data),
  logout: () => api.auth.logout(),
  updatePassword: (data: {newPassword: string}) => api.auth.updatePassword(data),
  getUserRole: (userId: string) => api.userRoles.get(userId),
  updateUserRole: (data: any) => api.userRoles.update(data),
  createUser: (data: any) => api.users.create(data),
  getUserByEmail: (email: string) => api.users.getByEmail(email),
};
